import styled from 'styled-components';

export const LoadingMessage = styled.div`
text-align: center;
padding: 20px;
color: #666;
`;

export const ErrorMessage = styled.div`
text-align: center;
padding: 20px;
color: #dc3545;
`;

export const SuccessMessage = styled.div`
text-align:center;
padding:20px;
bgcolor:var(--success-bgcolor);
color:white;
`;